import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteUser } from '../api/USERS/users';

export const useDeleteUser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (userId) => deleteUser(userId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
        },
    });
};